import {api} from '@/http'

// 近期面试列表
const getInterviewList = (data, callback, back) => {
  api('/api/interview', 'get', data, callback, back)
}

// 近期投递列表
const getDeliveryList = (data, callback, back) => {
  api('/api/delivery', 'get', data, callback, back)
}

export default {
  getInterviewList,
  getDeliveryList
}



// WEBPACK FOOTER //
// ./src/api/interview/index.js